import script from "./BusinessVenueEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./BusinessVenueEditor.vue?vue&type=script&setup=true&lang=js"

import "./BusinessVenueEditor.vue?vue&type=style&index=0&id=6dedefef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dedefef"]])

export default __exports__